import React, { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import Card from "../../../UI/Card/Card";
import Button from "../../../UI/Button/Button";
import ErrorPanel, { ErrorSize } from "../../../UI/ErrorPanel/ErrorPanel";

import { faSync, faCopy, faExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import * as ApplicationsUtils from "../../../Utils/ApplicationsUtils";
import * as ApplicationsActions from "../../../../middleware/Store/Actions/ApplicationsActions";
import * as SandBoxApplicationsActions from "../../../../middleware/Store/Actions/SandBoxApplicationsActions";
import * as ErrorUtils from "../../../Utils/ErrorUtils";
import DeleteModal from "../../../UI/Modal/DeleteModal";
import LogService from "../../../../middleware/CommonSdk/LogService";

const LOG_TAG = "APP-EDITION-IDENTIFICATION";

const Identification = (props) => {
    const intl = useIntl();
    const [modal, setModal] = useState(null);
    const [application, setApplication] = useState(null);
    const [progress, setProgress] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        LogService.trace(LOG_TAG, "useEffect application");
        if (props.applicationId) {
            let foundApplication = ApplicationsUtils.getApplicationById(props.applicationId, props.applications);
            setApplication(foundApplication);

            if (props.applicationId !== application?.id) {
                setProgress(false);
                setErrorMessage("");
            }
        }
    }, [props.applications, props.applicationId]);

    const displayWarningModal = () => {
        setModal(
            <DeleteModal
                title={intl.messages.applicationEditionIdentificationRenewApplicationSecret}
                icon={faExclamation}
                btnlabel={intl.messages.applicationEditionIdentificationRenewApplicationSecret}
                onClick={handleUpdate}
                showModalOnInit={true}
            >
                <p>{intl.messages.applicationEditionIdentificationRenewApplicationSecretWarningMessage}</p>

            </DeleteModal>
        );
    }

    const handleUpdate = (event) => {
        LogService.trace(LOG_TAG, "handleUpdate");
        const criteria = {
            refreshAppSecret: true
        };

        setProgress(true);
        props.update(application?.id, criteria)
            .then(() => {
                LogService.debug(LOG_TAG, "handleUpdate success");
                setProgress(false);
            })
            .catch((errorPayload) => {
                LogService.debug(LOG_TAG, "handleUpdate error");
                setProgress(false);
                setErrorMessage(ErrorUtils.getPrettyErrorMessage(errorPayload, intl));
            });
    };

    LogService.trace(LOG_TAG, "render");
    return (
        <Card title={intl.messages.applicationEditionIdentificationTitle} header={props.showHeader}>
            {modal}
            <div className="form-group">
                <label htmlFor="inputAppliId" className="input-label">{intl.messages.applicationEditionIdentificationApplicationId}</label>
                <div className="input-group mb-3">
                    <input
                        id="inputAppId"
                        disabled
                        type="text"
                        className="form-control"
                        autoComplete="off"
                        value={application ? application.id : ""}
                    />
                    <div className="input-group-append">
                        <button id="idCopyButton" className="btn input-btn" type="button" onClick={() => { navigator.clipboard.writeText(application?.id) }}>
                            <FontAwesomeIcon icon={faCopy} />
                        </button>
                    </div>
                </div>
            </div>

            {application?.appSecret?.length > 0 &&
                <div className="form-group">
                    <label htmlFor="inputAppliSecret" className="input-label">{intl.messages.applicationEditionIdentificationApplicationSecret}</label>
                    <div className="input-group mb-3">
                        <input
                            id="inputAppSecret"
                            disabled
                            type="text"
                            className="form-control"
                            autoComplete="off"
                            value={application?.appSecret}
                        />
                        <div className="input-group-append">
                            <button id="secretCopyButton" className="btn input-btn" type="button" onClick={() => { navigator.clipboard.writeText(application?.appSecret) }}>
                                <FontAwesomeIcon icon={faCopy} />
                            </button>
                        </div>
                    </div>
                </div>
            }

            {props.isUpdateEnabled &&
                <div>
                    <Button
                        id="updateButton"
                        label={intl.messages.applicationEditionIdentificationRenewApplicationSecret}
                        icon={faSync}
                        onClick={displayWarningModal}
                        spinner={progress}
                        disabled={progress}
                        className="btn-submit"
                    />
                    {errorMessage &&
                        <div className="col-10 float-right">
                            <ErrorPanel size={ErrorSize.Small} >{errorMessage}</ErrorPanel>
                        </div>
                    }
                </div>
            }
        </Card >
    );
}

Identification.propTypes = {
    applicationId: PropTypes.string,
    isUpdateEnabled: PropTypes.bool,
    showHeader: PropTypes.bool,
    isSandBoxApplication: PropTypes.bool
};

Identification.defaultProps = {
    applicationId: "",
    isUpdateEnabled: false,
    showHeader: true,
    isSandBoxApplication: false
}

const mapStateToProps = (state, props) => {
    return {
        applications: props.isSandBoxApplication ? state.sandBoxApplications.applications : state.applications.applications
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        update: (appId, criteria) => dispatch(props.isSandBoxApplication ? SandBoxApplicationsActions.updateApplication(appId, criteria) : ApplicationsActions.updateApplication(appId, criteria))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Identification);